import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=2fc72fb8&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports